module.exports = __webpack_public_path__ + "img/multidevice_img.071f4162.png";